import type { ActivityInstanceOut } from "../../../api/opsV2";
import { getActivityPanel } from "./activity/activityPanelRegistry";
import { ValidationErrorPanel } from "./ValidationErrorPanel";
import type { OpsV2Error } from "../../../api/opsV2";
import { X } from "lucide-react";

type ActivityCompleteDrawerProps = {
  activity: ActivityInstanceOut;
  onClose: () => void;
  onSubmit: (activityId: string, runInput: Record<string, unknown>) => Promise<void>;
  submitError: OpsV2Error | null;
  onDismissError: () => void;
  submitting: boolean;
};

export function ActivityCompleteDrawer({
  activity,
  onClose,
  onSubmit,
  submitError,
  onDismissError,
  submitting,
}: ActivityCompleteDrawerProps) {
  const Panel = getActivityPanel(activity.activity_type);

  const handleSubmit = (runInput: Record<string, unknown>) => {
    onSubmit(activity.id, runInput);
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/40" aria-hidden onClick={onClose} />
      <div className="relative w-full max-w-md border-l border-border bg-surface shadow-xl sm:max-w-lg">
        <div className="flex items-center justify-between border-b border-border p-4">
          <h2 className="text-lg font-semibold text-text">Compléter : {activity.title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-muted-foreground hover:bg-surface-muted hover:text-text"
            aria-label="Fermer"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="max-h-[calc(100vh-8rem)] overflow-auto p-4">
          {submitError && (
            <div className="mb-4">
              <ValidationErrorPanel
                message={submitError.message}
                validationErrors={submitError.validationErrors}
                onDismiss={onDismissError}
              />
            </div>
          )}
          {Panel ? (
            <Panel
              activityType={activity.activity_type}
              activityTitle={activity.title}
              initialValues={activity.run_input_json ?? undefined}
              onSubmit={handleSubmit}
              onCancel={onClose}
              submitting={submitting}
            />
          ) : (
            <p className="text-sm text-muted-foreground">
              Type d'activité « {activity.activity_type} » sans formulaire dédié. Utilisez l'API pour compléter.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
